import styled, { css, DefaultTheme } from "styled-components";
import { typographyCSS } from "@ifgengineering/design-tokens/legacy";

export type V3KVRowTone = "default" | "positive" | "negative" | "warning";

const VALUE_COLOUR: Record<V3KVRowTone, (theme: DefaultTheme) => string> = {
  default: (theme) => theme.colors.ui.text.primary,
  positive: (theme) => theme.colors.ui.text.success,
  negative: (theme) => theme.colors.ui.text.error,
  warning: (theme) => theme.colors.ui.text.warning,
};

export const Row = styled.div<{ $divider: boolean }>`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: ${({ theme }) => theme.space.md}px;
  padding: ${({ theme }) => theme.space.md}px 0;

  ${({ theme, $divider }) =>
    $divider &&
    css`
      border-bottom: ${theme.stroke.md}px solid
        ${theme.colors.ui.border.divider};
    `}

  &:last-child {
    border-bottom: none;
  }
`;

export const LabelGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space["3xs"]}px;
  min-width: 0;
`;

export const Label = styled.span`
  ${typographyCSS("body.sm")}
  color: ${({ theme }) => theme.colors.ui.text.secondary};
`;

export const Hint = styled.span`
  ${typographyCSS("caption.sm")}
  color: ${({ theme }) => theme.colors.ui.text.tertiary};
`;

export const ValueGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.space.sm}px;
  min-width: 0;
`;

export const Value = styled.span<{ $tone: V3KVRowTone; $emphasis: boolean }>`
  ${({ $emphasis }) =>
    typographyCSS($emphasis ? "heading.2xs" : "label.sm-semibold")}
  color: ${({ theme, $tone }) => VALUE_COLOUR[$tone](theme)};
  text-align: right;
`;
